<template>
  <div class="card">
    <b-form-group v-slot="{ ariaDescribedby }">
      <div class="dow-header">
        <span class="dow-label">Day of the week:</span>
        <b-form-checkbox
          v-model="selectAll"
          @change="onSelectAll"
          class="select-all-checkbox"
          >Every day</b-form-checkbox
        >
      </div>
      <b-form-checkbox-group
        id="checkbox-group-1"
        v-model="selected"
        :options="options"
        :aria-describedby="ariaDescribedby"
        name="flavour-1"
      ></b-form-checkbox-group>
    </b-form-group>
    <b-form-timepicker
      placeholder="Choose a time"
      id="timepicker"
      size="sm"
      locale="en"
      class="mb-2"
      v-model="time"
    ></b-form-timepicker>
  </div>
</template>

<script>
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  props: {
    value: {
      type: String
    }
  },
  data() {
    return {
      selectAll: false,
      cronExpression: "",
      time: "16:00:00",
      selected: [],
      options: [
        { text: "Sun", value: "0" },
        { text: "Mon", value: "1" },
        { text: "Tue", value: "2" },
        { text: "Wed", value: "3" },
        { text: "Thu", value: "4" },
        { text: "Fri", value: "5" },
        { text: "Sat", value: "6" }
      ],
      weeks: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]
    };
  },
  created() {
    this.calcCron();
  },
  methods: {
    onSelectAll(checked) {
      this.selected = checked ? this.options.map(o => o.value) : [];
    },
    getCronExpression() {
      const weeksNumbers = this.selected;
      const timeArray = this.time.split(":");
      const selectedWeeks = [];
      for (const week of weeksNumbers) {
        const weekNew = parseInt(week);
        selectedWeeks.push(this.weeks[weekNew]);
      }
      const days = selectedWeeks.join(",");
      this.cronExpression = `${timeArray[1]} ${timeArray[0]} ? * ${days} *`;
    },
    calcCron() {
      if (!this.value) return;

      // Strip "cron(...)" wrapper if present
      let raw = this.value.trim();
      if (raw.startsWith("cron(") && raw.endsWith(")")) {
        raw = raw.slice(5, -1);
      }

      const timeArray = raw.split(" ");
      if (timeArray.length !== 6) return;

      const minute = timeArray[0].padStart(2, "0");
      const hour = timeArray[1].padStart(2, "0");
      this.time = `${hour}:${minute}:00`;

      const dayField = timeArray[4];
      let selectedWeeks;

      if (!dayField || dayField === "?") {
        selectedWeeks = [];
      } else if (dayField === "*") {
        selectedWeeks = this.options.map(o => o.value);
      } else if (dayField.includes("-")) {
        const parts = dayField.split("-");
        const rangeWeeks = parts.map(item => this.getWeekNumber(item));
        selectedWeeks = this.getWeeks(rangeWeeks[0], rangeWeeks[1]);
      } else if (dayField.includes(",")) {
        selectedWeeks = dayField
          .split(",")
          .map(item => this.getWeekNumber(item));
      } else {
        selectedWeeks = [this.getWeekNumber(dayField)];
      }

      if (selectedWeeks) {
        this.selected = selectedWeeks;
      }
    },
    getWeeks(weekBegin, weekEnd) {
      const weeks = [];
      // Handle wrap-around ranges like MON(1)-SUN(0)
      if (weekBegin <= weekEnd) {
        for (let index = weekBegin; index <= weekEnd; index++) {
          weeks.push(String(index));
        }
      } else {
        // Wrap around: e.g. MON(1) to SUN(0) → 1,2,3,4,5,6,0
        for (let index = weekBegin; index <= 6; index++) {
          weeks.push(String(index));
        }
        for (let index = 0; index <= weekEnd; index++) {
          weeks.push(String(index));
        }
      }
      return weeks;
    },
    getWeekNumber(week) {
      const trimmed = week.trim();
      // Handle numeric values directly
      if (!isNaN(trimmed)) {
        return String(parseInt(trimmed) % 7); // normalize to 0-6
      }
      const found = this.options.find(
        t => t.text.toLowerCase() === trimmed.toLowerCase()
      );
      return found ? found.value : null;
    }
  },
  watch: {
    time() {
      this.getCronExpression();
      this.$emit("input", this.cronExpression);
    },
    selected() {
      this.selectAll = this.selected.length === this.options.length;
      this.getCronExpression();
      this.$emit("input", this.cronExpression);
    },
    value() {
      this.calcCron();
    }
  }
};
</script>

<style lang="scss" scoped>
.dow-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 8px;
}
.dow-label {
  font-weight: 600;
}
</style>
